export default "__VITE_ASSET__de1fb8ae__"